import React, { ComponentProps } from 'react';
import {
  Modal,
  ModalProps,
  Paper
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: '95%',
      maxHeight: '95vh'
    },
    header: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing()
    },
    body: {
      flex: 1,
      overflow: 'auto',
      padding: theme.spacing()
    },
    footer: {
      borderTop: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing()
    }
  };
});

export interface GenericModalProps extends Omit<ModalProps, 'children'> {
  children?: ComponentProps<any>['children']
  header?: ComponentProps<any>['children']
  footer?: ComponentProps<any>['children']
  size?: number,
  fixExpand?: boolean
}

export const GenericModal = (props: GenericModalProps) => {
  const classes = useStyles();
  const {
    size = 650,
    fixExpand = false,
    ...restProps
  } = props;

  const finalProps = {
    ...restProps,
    className: [props.className, classes.modal].filter(a => a).join(' ')
  };

  const wrapperStyle = {
    maxWidth: `${size}px`,
    height: fixExpand ? '100%' : undefined,
    width: fixExpand ? '100%' : undefined
  };

  const bodyStyle = {
    height: fixExpand ? '100%' : undefined,
    width: fixExpand ? '100%' : undefined
  };


  return (
    <Modal {...finalProps}>
      <Paper className={classes.wrapper} style={wrapperStyle}>
        {!!props.header && (<div className={classes.header}>{props.header}</div>)}
        <div className={classes.body} style={bodyStyle}>{props.children}</div>
        {!!props.footer && (<div className={classes.footer}>{props.footer}</div>)}
      </Paper>
    </Modal>
  );
};
